import { InjectionToken } from '@angular/core';
import { app } from 'firebase-admin';

export const FIREBASE_ADMIN = new InjectionToken<app.App>('FIREBASE_ADMIN');
